import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
    state:{
        isDevMode: '', // 开发者模式
        payList:[],
        payHtml:"",
        locationObj:null,
        onlyMark:0,
        dataObj:null,//套餐充值详情
        loginStatus: false,
        expriyTimeStamp: '',//有效期截止时间戳
        indate: 1, //有效期时长
        phonenumber: '',
        userInfo:{},//用户信息
        cars:[],// 车辆管理
        browserType: '',
        originalId: '',
    },
    mutations:{
        setDevMode(state,isDevMode){ // 开发者模式
            state.isDevMode = isDevMode;
        },
        setPayList(state,data){//更改支付方式列表
            state.payList = data;
        },
        setUserInfo(state,data){//更新用户登录状态
            state.phonenumber = data;
            state.loginStatus = true;
        },
        logout(state,data){
            state.phonenumber = '';
            state.loginStatus = false;
        },
        getBindCars(state,data){ // 登录保存车辆信息
            state.cars = data;
        },
        addCar(state,car){ // 增加车辆
            state.cars.push(car);
        },
        deleteCar(state,startIndex){ // 删除车辆
            state.cars.splice(startIndex,1);
        },
        getBrowerType(state,browserType){ // 获取浏览器类型
            state.browserType = browserType;
        },
        setOriginalId(state,originalId){
            state.originalId = originalId;
        },
        setExpriyTimeStamp(state,data){ //设置过期截止时间戳
            state.expriyTimeStamp = data;
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js